import { useContinueExecutionAfterCsat } from 'components/App/hooks/useContinueExecutionAfterCsat';
import { useAppDispatch } from 'hooks';
import { useCallback } from 'react';
import { setCsatStatesByKey } from 'reducers/workflows';

export const useContinueConversationExecution = () => {
  const dispatch = useAppDispatch();
  const continueExecutionAfterCsatDismiss = useContinueExecutionAfterCsat();

  return useCallback(() => {
    dispatch(setCsatStatesByKey({ hasDismissed: true, isCsatVisible: false }));
    continueExecutionAfterCsatDismiss();
  }, [continueExecutionAfterCsatDismiss, dispatch]);
};
